import { StateSchema } from 'app/config/storeConfig/types';

export const getReservationId = (state: StateSchema): Nullable<string> => state.reservationDetailsDrawer.reservationId;
